<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <div class="row">
      <div class="text-right align-self-end">
        <button
          @click="() => $router.push({ name: 'DetailSurvey' })"
          class="btn btn-outline-primary"
        >
          Create
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <BrandDropdown
          v-model="brandSelected"
          @setBrand="setBrand"
        ></BrandDropdown>
      </div>
      <div class="col-4">
        <label for="searchName">Name</label>
        <input
          id="searchName"
          type="text"
          class="form-control py-2"
          v-model="searchName"
        />
      </div>
      <div class="col-2">
        <label for="statusSelected">Status</label>
        <multiselect
          id="statusSelected"
          v-model="statusSelected"
          :options="statusOptions"
          label="text"
          track-by="text"
        >
        </multiselect>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <div class="p-2 align-self-center">
        <button class="btn btn-outline-secondary" @click="resetFilter">
          Reset
        </button>
      </div>
      <div class="p-2 align-self-center">
        <button
          class="btn btn-outline-primary"
          style="width: 100%; max-width: 131px"
          @click="searchSurvey"
        >
          Search
        </button>
      </div>
    </div>

    <div class="mt-3">
      <div class="row">
        <div class="d-flex align-items-center justify-content-start col">
          <span class="mr-2">Show</span>
          <b-form-select
            class="form-control w-auto"
            v-model="perPage"
            :options="pageOptions"
            @change="onChangeEntries"
          ></b-form-select>
          <span class="ml-2">entries</span>
        </div>
      </div>
      <b-table
        class="table table-responsive table-bordered mt-5"
        hover
        responsive
        :fields="fields"
        :items="listSurveys"
        :per-page="perPage"
        @sort-changed="sortCompare"
        show-empty
      >
        <template #empty>
          <h1 class="text-center m-5">ไม่มีข้อมูลที่แสดง</h1>
        </template>
        <template #cell(action)="data">
          <div class="d-flex justify-content-evenly">
            <router-link
              :to="{
                name: 'DetailSurvey',
                query: { id: data.item.id },
              }"
              class="btn btn-outline-primary"
              >View</router-link
            >
          </div>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        @input="changePage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import BrandDropdown from "components/Brand/BrandDropdown";
import DefaultListViewData from "@/views/defaultListViewData";
import SurveyService from "services/api/survey.service";
import fields from "./listSurveyfields.json";

export default {
  components: {
    BrandDropdown,
  },

  data() {
    return {
      ...DefaultListViewData,
      searchName: null,
      statusSelected: null,
      statusOptions: [{ text: "Active" }, { text: "Inactive" }],
      isLoading: true,
      listSurveys: [],
      fields,
      isSubmit: false,
    };
  },
  mounted() {
    this.getSurveys(this.sort);
  },
  methods: {
    async getSurveys(sort) {
      const params = {
        brandCode: this.brandSelected ? this.brandSelected.id : null,
        name: this.searchName,
        active: this.statusSelected
          ? this.statusSelected.text?.toUpperCase()
          : null,
        currentPage: this.currentPage,
        limit: this.perPage,
        sortColumn: sort.key || "id",
        sortType: sort.type === "asc" ? "asc" : "desc",
      };

      await SurveyService.getListSurvey(params)
        .then((res) => {
          const data = res.data;
          this.totalItems = data.totalItem;
          this.listSurveys = data.data.map((c) => {
            return {
              ...c,
              status: c.status === "ACTIVE" ? "Active" : "Inactive",
            };
          });

          this.isLoading = false;
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.isLoading = false;
        });
    },
    changePage() {
      this.getSurveys(this.sort);
    },
    onChangeEntries() {
      this.getSurveys(this.sort);
    },
    sortCompare(e) {
      let sortBy = e.sortBy;
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getSurveys(this.sort);
    },
    setBrand(brand) {
      this.brandSelected = brand || null;
    },
    searchSurvey() {
      this.isLoading = true;
      this.getSurveys(this.sort);
    },
    resetFilter() {
      this.brandSelected = null;
      this.searchName = null;
      this.statusSelected = null;
      this.getSurveys(this.sort);
    },
  },
};
</script>

<style lang="scss" scoped>
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
</style>
